import initialState from './initialState';
import Actions from './actions';

export default function global(state = initialState, action: any) {
  switch (action.type) {
    case Actions.GET_VIDEO_REQUEST:
      return {
        ...state,
        video: {
          ...state.video,
          loading: true,
          loaded: false,
          data: [],
        }
      }

    case Actions.GET_VIDEO_SUCCESS:
      return {
        ...state,
        video: {
          ...state.video,
          loading: false,
          loaded: true,
          data: [
            ...action.payload.data,
          ]
        }
      }

    case Actions.GET_VIDEO_ERROR:
      return {
        ...state,
        video: {
          ...state.video,
          loading: false,
          loaded: false,
          data: [],
        }
      }

    default:
      break;
  }
  return state
}
